export const msalConfig = {
  // VIACREDI PRODUCTION ==========
  auth: {
    clientId: "dffa9ec1-65fe-4d7d-8ac4-32ede872631e",
    authority: "https://login.microsoftonline.com/7e15f674-853f-4708-8271-75b08833eb8c",
    redirectUri: "https://app.contasalario.towty.com.br",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  }

  // VIACREDI HOMOLOG ==========
  // auth: {
  //   clientId: "5ace34e5-25a8-4230-9577-122a4732c7a0",
  //   authority: "https://login.microsoftonline.com/7e15f674-853f-4708-8271-75b08833eb8c",
  //   redirectUri: "https://demo.contasalario.towty.com.br",
  // },
  // cache: {
  //   cacheLocation: "sessionStorage",
  //   storeAuthStateInCookie: false,
  // }

  // VIACREDI LOCALHOST ==========
  // auth: {
  //   clientId: "dffa9ec1-65fe-4d7d-8ac4-32ede872631e",
  //   authority: "https://login.microsoftonline.com/7e15f674-853f-4708-8271-75b08833eb8c",
  //   redirectUri: "http://localhost:3000",
  // },
  // cache: {
  //   cacheLocation: "sessionStorage",
  //   storeAuthStateInCookie: false,
  // }
};

export const loginRequest = {
  scopes: ["User.Read"]
};
